import axios from 'axios';

const locale = document.documentElement.lang || 'zh-tw';
const api = axios.create({
  baseURL: `/${locale}/api/`,
  timeout: 120 * 1000,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  }
});

api.postFormData = function(url, data, config) {
  const formData = composeFormData(data);

  return this.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });
}

export const setLocale = (locale) => {
  api.defaults.baseURL = `/${locale}/api/`;
}

let errorCallback = null;
export const catchUnauthorized = (callback) => {
  errorCallback = callback;
}

api.interceptors.response.use((response) => {
  return response;
}, function (error) {
  if (error.response && error.response.status && error.response.status == 401) {
    errorCallback ? errorCallback(error) : null;
  } else {
    console.error(error);
    if (window.bugsnagClient) {
      window.bugsnagClient.notify(error);
    }
  }

  return Promise.reject(error);
});

export const composeFormData = function (data) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

const buildFormData = function(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
    return;
  }

  if (data != null) {
    formData.append(parentKey, data);
  }
}

export default api;
